
import { component } from '@/helpers/vueTyped';

interface IntersectionObserverMarkerInit {
    root?: () => HTMLElement;
    rootMargin?: string;
    threshold?: number | number[];
}

interface IntersectionObserverMarkerOptions {
  options?: IntersectionObserverMarkerInit;
  callback: (entries: IntersectionObserverEntry[]) => void;
}

interface IntersectionObserverMarkerProps {
  start: IntersectionObserverMarkerOptions;
  end?: IntersectionObserverMarkerOptions;
}

export default component<IntersectionObserverMarkerProps>()({
  name: 'IntersectionObserverMarker',

  props: {
    start: {},
    end: {},
  },

  data() {
    return {
      endObserver: null as unknown as IntersectionObserver,
      startObserver: null as unknown as IntersectionObserver,
    };
  },

  methods: {
    observeRailStart() {
      const railstartmarker = this.$refs.railstartmarker as HTMLElement;
      this.startObserver.observe(railstartmarker);
    },

    observeRailEnd() {
      const railendmarker = this.$refs.railendmarker as HTMLElement;
      this.endObserver.observe(railendmarker);
    },

    generateOptions(observerOptions: IntersectionObserverMarkerOptions) {
      return {
        root: observerOptions.options?.root?.(),
        rootMargin: observerOptions.options?.rootMargin,
        threshold: observerOptions.options?.threshold,
      };
    },
  },

  mounted() {
    this.startObserver = new IntersectionObserver(this.start.callback, this.generateOptions(this.start));
    this.observeRailStart();

    if (this.end) {
      this.endObserver = new IntersectionObserver(this.end.callback, this.generateOptions(this.end));
      this.observeRailEnd();
    }
  },

  destroyed() {
    if (this.startObserver) {
      this.startObserver.disconnect();
    }

    if (this.endObserver) {
      this.endObserver.disconnect();
    }
  },

  render() {
    return (
      <div>
        <div ref='railstartmarker'/>
        {this.$slots.default}
        {this.end && <div ref='railendmarker'/>}
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-2a619b08/IntersectionObserverMarker.vue" });